/* Zur Kiepe – Nachtangeln · global.js */
(function(){
  'use strict';

  // Mobile drawer
  var drawer = document.querySelector('[data-drawer]');
  document.addEventListener('click', function(e){
    var open = e.target.closest('[data-drawer-open]');
    var close = e.target.closest('[data-drawer-close]');
    var scrim = e.target.classList && e.target.classList.contains('drawer__scrim');
    if(open && drawer){ drawer.classList.add('open'); document.body.style.overflow='hidden'; }
    if((close || scrim) && drawer){ drawer.classList.remove('open'); document.body.style.overflow=''; }
  });

  // Reveal on scroll
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold:.12 });
    document.querySelectorAll('[data-reveal]').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function(el){ el.classList.add('in'); });
  }

  // Product gallery thumbs
  document.addEventListener('click', function(e){
    var thumb = e.target.closest('[data-thumb]');
    if(thumb){
      var main = document.querySelector('[data-main-image]');
      if(main){ main.src = thumb.getAttribute('data-full') || thumb.src; }
    }
  });

  // Quantity steppers
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-qty]');
    if(!btn) return;
    var input = btn.parentNode.querySelector('input');
    if(!input) return;
    var v = parseInt(input.value || '1', 10);
    v += (btn.getAttribute('data-qty') === 'up') ? 1 : -1;
    if(v < 1) v = 1;
    input.value = v;
  });

  // Ajax add-to-cart on product cards
  document.addEventListener('submit', function(e){
    var form = e.target.closest('[data-quick-add]');
    if(!form) return;
    e.preventDefault();
    var btn = form.querySelector('button'); var label = btn ? btn.textContent : '';
    if(btn){ btn.textContent = '…'; btn.disabled = true; }
    fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/x-www-form-urlencoded', 'Accept':'application/json' },
      body: new URLSearchParams(new FormData(form)).toString()
    }).then(function(r){ return r.json(); })
      .then(function(){ return fetch('/cart.js'); })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var badge = document.querySelector('[data-cart-count]');
        if(badge){ badge.textContent = cart.item_count; badge.classList.remove('hide'); }
        if(btn){ btn.textContent = '✓'; setTimeout(function(){ btn.textContent = label; btn.disabled = false; }, 1200); }
      })
      .catch(function(){ if(btn){ btn.textContent = label; btn.disabled = false; } window.location='/cart'; });
  });
})();
